import { Component } from 'react';
import isValid from 'date-fns/isValid';
import isEqual from 'date-fns/isEqual';
import parseISO from 'date-fns/parseISO';
import PropTypes from 'prop-types';

const PropTypesValidDateOrString = (props, propName, componentName) => {
  let value = props[propName];

  if (typeof value === 'string') {
    value = parseISO(value);
  }

  if (!isValid(value)) {
    return new Error(
      `Invalid date string on prop \`${propName}\` supplied to \`${componentName}\`. Validation failed.`,
    );
  }
};

class GuideContainer extends Component {
  static propTypes = {
    start: PropTypesValidDateOrString,
    stop: PropTypesValidDateOrString,
    hoursFormatString: PropTypes.string,
    categoryHeight: PropTypes.number.isRequired,
    channelHeight: PropTypes.number.isRequired,
    sort: PropTypes.func,
    filter: PropTypes.func,
    defaultFirstItemIndex: PropTypes.number,
    defaultFirstItemSlug: PropTypes.string,
    playerHasContent: PropTypes.bool.isRequired,
    section: PropTypes.string,

    loadData: PropTypes.func.isRequired,
    playCurrentOrDefaultIndex: PropTypes.func.isRequired,
    synchPlayerIndex: PropTypes.func.isRequired,
    categoryItemsMutator: PropTypes.func,
    children: PropTypes.node,
  };

  static defaultProps = {
    hoursFormatString: 'p',
    sort: undefined,
    filter: undefined,
    defaultFirstItemIndex: 1,
    categoryItemsMutator: undefined,
    children: null,
    section: null,
    synchPlayerIndex: () => {},
  };

  state = {
    loadParamsLog: [],
  };

  componentDidMount() {
    if (!this.props.section || this.props.section === 'live') {
      this.loadData();
    }
  }

  shouldComponentUpdate(nextProps) {
    const startChanged = !isEqual(parseISO(nextProps.start), parseISO(this.props.start));
    const stopChanged = !isEqual(parseISO(nextProps.stop), parseISO(this.props.stop));
    const sectionChanged = nextProps.section === 'live' && nextProps.section !== this.state.section;
    return startChanged || stopChanged || sectionChanged;
  }

  componentDidUpdate() {
    this.loadData();
  }

  logLoadParams = () => {
    const { start, stop } = this.props;
    const params = { start, stop };

    let result = false;
    if (
      this.state.loadParamsLog.some((log) => log.start === start && log.stop === stop) === false
    ) {
      this.setState((state) => ({
        loadParamsLog: [params, ...state.loadParamsLog],
      }));
      result = true;
    }
    return result;
  };

  loadData = async () => {
    const {
      loadData,
      start,
      stop,
      sort,
      filter,
      categoryItemsMutator,
      hoursFormatString,
      categoryHeight,
      channelHeight,
    } = this.props;

    const successLogged = this.logLoadParams();

    if (successLogged) {
      await loadData({
        start,
        stop,
        categoryHeight,
        channelHeight,
        categoryItemsMutator,
        fetchParams: {
          sort,
          filter,
        },
        setHoursParams: {
          formatString: hoursFormatString,
        },
      }).catch((err) => console.error(err));

      if (!this.props.playerHasContent) {
        await this.playCurrentOrDefaultIndex();
      } else {
        await this.props.synchPlayerIndex();
      }
    } else {
      console.warn('Period already loaded', { start, stop });
    }
  };

  playCurrentOrDefaultIndex = () => {
    const { playCurrentOrDefaultIndex, defaultFirstItemIndex, defaultFirstItemSlug } = this.props;

    playCurrentOrDefaultIndex({ defaultFirstItemIndex, defaultFirstItemSlug });
  };

  render() {
    return this.props.children;
  }
}

export { GuideContainer };
